import { PharmacySegment } from '../../../../../pages/admin-dashboard/pharmacy-segment/pharmacy-segment.model';

export interface SegmentHeaderItem {
  key: string;
  label: string;
  type?: string;
}

export interface PharmacySegmentRow extends Omit<PharmacySegment, 'createdBy' | 'lastModifiedBy'> {
  index: number;
  titleDisplay: string;
  paymentTermDisplay: string;
  extraDiscountDisplay: string;
  createdOn: string;
  createdBy: string;
  lastModifiedOn: string | null;
  lastModifiedBy: string;
}

export const SEGMENT_ACTION_EDIT = 1;